import React, { createContext, useState, useEffect } from 'react';
import {
  clearCliqloanSession,
  consumeSessionHandoffFromHash,
  isCliqloanLoggedIn,
} from './utils/cliqloanSession';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    consumeSessionHandoffFromHash();
    return isCliqloanLoggedIn();
  });

  const logout = () => {
    clearCliqloanSession();
    setIsLoggedIn(false);
  };

  const refreshAuth = () => {
    setIsLoggedIn(isCliqloanLoggedIn());
  };

  useEffect(() => {
    consumeSessionHandoffFromHash();
    refreshAuth();

    const onStorage = (event) => {
      if (
        event.key === 'cliqloan-user-app-session' ||
        event.key === 'cliqloan-user-user-session'
      ) {
        refreshAuth();
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, logout, refreshAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
